<template>
  <el-dialog title="人脸库信息修改" :visible.sync="visible" width="700px" :before-close="closeDialog" @open="loadBucket">
    <el-form v-if="bucket" ref="form" :model="bucket" :rules="rules" style="width:600px" label-width="100px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="bucket.name"></el-input>
      </el-form-item>
      <el-form-item label="延期" prop="_expired">
        <el-radio-group v-model="bucket._expired">
          <el-radio label>不延期</el-radio>
          <el-radio label="6 months">半年</el-radio>
          <el-radio label="1 years">一年</el-radio>
          <el-radio label="3 years">三年</el-radio>
          <el-radio :label="0">无限期</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item align="center">
        <el-button @click="$refs.form.resetFields()">重 置</el-button>
        <el-button @click="submit" type="primary">提 交</el-button>
        <el-button type="danger" @click="drop">删 除</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { rules } from "@/utils";
import moment from "moment";

export default {
  props: {
    bucketId: Number,
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bucket: null,
      rules: {
        name: [rules.required()]
      }
    };
  },
  methods: {
    ...mapActions("bucket", ["update", "remove"]),
    async loadBucket() {
      if (!this.bucketId) {
        this.closeDialog();
        this.$message.error("缺少人脸库ID");
      }else{
        let bucket = await Vue.store.dispatch("bucket/get", {id: this.bucketId});
        this.bucket = { ...bucket, _expired: "" };
      }
    },
    async submit() {
      let ok = await this.$refs.form.validate();
      if (!ok) {
        return;
      }
      let expired = this.bucket._expired;
      if (expired === 0) {
        expired = 0;
      } else if (expired === "") {
        expired = undefined;
      } else {
        let [n, unit] = expired.split(" ");
        expired = moment(this.bucket.expired)
          .add(parseInt(n), unit)
          .valueOf();
      }
      let res = await this.update({ ...this.bucket, expired });
      this.$message.success("更新成功");
      this.closeDialog();
    },
    drop() {
      let msg = `删除 ${this.bucket.name} 将会移除人脸模型、调用日志，且不可恢复`;
      this.$confirm(msg, { type: "warning" })
        .then(() => this.remove(this.bucket))
        .then(() => {
          this.$message("移除成功");
          this.closeDialog();
        });
    },
    closeDialog() {
      this.$emit('update:visible', false);
      this.bucket = null;
    }
  }
};
</script>

<style>
</style>
